import { render, staticRenderFns } from "./Disapprove.vue?vue&type=template&id=1eec36ce"
import script from "./Disapprove.vue?vue&type=script&lang=js"
export * from "./Disapprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports